import { io, Socket } from "socket.io-client";

const isProduction = process.env.NODE_ENV === "production";

const URL = isProduction
  ? "https://backend.lavishkallp.com"
  : "http://localhost:4000";

export const socket: Socket<any, any> = io(URL, {
  auth: {
    token: `${sessionStorage.getItem("token")}`,
  },
});
